var generateStyle = function generateStyle(componentTheme) {
  return {
    page: {
      boxSizing: 'border-box',
      padding: componentTheme.pagePadding,
      height: '100%'
    },
    children: {
      display: 'flex',
      flexWrap: 'wrap',
      margin: componentTheme.childrenMargin
    },
    title: {
      marginBottom: componentTheme.titleMarginBottom
    }
  };
};
export default generateStyle;